// tslint:disable: variable-name
import { Indicador } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { AcaoGoverno } from './acao-governo.model';

export class IndicadorAdicional extends BaseResourceModel {
    constructor(
        public id?: number,
        public acao_governo?: AcaoGoverno,
        public indicador?: Indicador,
    ) {
        super();
    }

    static converteJson(json: any): IndicadorAdicional {
        return Object.assign(new IndicadorAdicional(), json);
    }
}
